import script from "./EmbroiderySizeConflictNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbroiderySizeConflictNotice.vue?vue&type=script&setup=true&lang=js"

import "./EmbroiderySizeConflictNotice.vue?vue&type=style&index=0&id=05982766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05982766"]])

export default __exports__